// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border-btn[data-v-29f584b2] {\n  border: 1.22px solid #224189;\n}\n.desktop-btn[data-v-29f584b2] {\n  width: 50%;\n  position: relative;\n}\n.btn-overlay[data-v-29f584b2] {\n  width: 100%;\n  position: relative;\n}\n.btn-overlay[data-v-29f584b2]:hover {\n  background-color: #ecf1fd !important;\n}\n", ""]);
// Exports
module.exports = exports;
